import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import { EnvService } from './env.service';
import { User } from '../models/user';
import { NavController, Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { AlertService } from './alert.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    authState = new BehaviorSubject(false);

    token: string;
    registerToken: any;
    tokenRefresh: string;
    isEnabled: boolean;

    headers = new HttpHeaders();

    constructor(private http: HttpClient,
        private storage: Storage,
        private env: EnvService,
        private navCtrl: NavController,
        private platform: Platform,
        private alertService: AlertService
    ) {

        this.platform.ready().then(() => {
            this.ifLoggedIn();
        });
        this.token = '';
    }

    ifLoggedIn() {
        this.storage.get('token').then((token) => {
            if (token) {
                this.headers = new HttpHeaders({
                    'Authorization': 'Bearer ' + token,
                    'x-static-key': this.env.X_STATIC_KEY
                });
                this.authState.next(true);
            }
        });
    }

    login(username: string, password: string) {
        let body = { 'username': username, 'password': password };
        this.http.post(this.env.API_URL + 'auth/login', body)
            .toPromise()
            .then(response => {
                if (response['enabled']) {

                    this.storage.set('token', response['token'])
                        .then(
                            () => {
                                this.token = response['token'];
                                this.tokenRefresh = response['refresh_token'];
                                this.headers = new HttpHeaders({
                                    'Authorization': 'Bearer ' + this.token,
                                    'x-static-key': this.env.X_STATIC_KEY
                                });

                                this.authState.next(true);
                                if (response['show_wizard']) {
                                    this.navCtrl.navigateRoot(['./wizard']);
                                } else {
                                    this.navCtrl.navigateRoot(['/tabs']);
                                }
                            },
                            error => console.error('Error saving token', error)
                        );

                    this.storage.set('refresh_token', response['refresh_token'])
                        .then(
                            () => {
                                this.tokenRefresh = response['refresh_token'];
                            },
                            error => console.error('Error saving refresh_token', error)
                        );

                } else {
                    this.alertService.presentToast('Usuario aún no confirmado por email');
                }

            }).catch(
                error => {

                }
            );
    }

    refreshToken() {
        this.storage.get('refresh_token').then((refresh_token) => {

            if (refresh_token) {
                let body = { 'refresh_token': refresh_token };
                const headerX = new HttpHeaders({
                    'x-static-key': this.env.X_STATIC_KEY
                });

                this.http.post(this.env.API_URL + 'auth/token/refresh', body, { headers: headerX })
                    .toPromise()
                    .then(
                        response => {
                            this.storage.set('token', response['token'])
                                .then(
                                    () => {
                                        this.token = response['token'];
                                        this.headers = new HttpHeaders({
                                            'Authorization': 'Bearer ' + this.token,
                                            'x-static-key': this.env.X_STATIC_KEY
                                        });

                                        if (response['enabled']) {
                                            this.http.get(this.env.API_URL + 'show-wizard', { headers: this.headers })
                                                .toPromise()
                                                .then(
                                                    response_wizard => {
                                                        if (response_wizard['show_wizard']) {
                                                            this.authState.next(true);
                                                            this.navCtrl.navigateRoot(['./wizard']);
                                                        } else {
                                                            this.navCtrl.navigateRoot(['/tabs']);
                                                            this.authState.next(true);
                                                        }
                                                    },
                                                    error => {
                                                    });
                                        } else {
                                            this.alertService.presentToast('Usuario aún no confirmado por email');

                                        }

                                    },
                                    error => {
                                        console.error('Error saving token', error);
                                    }
                                );
                            this.storage.set('refresh_token', response['refresh_token'])
                                .then(
                                    () => {
                                        this.tokenRefresh = response['refresh_token'];
                                    },
                                    error => {
                                        console.error('Error saving refresh_token', error);
                                    }
                                );
                        }
                    ).catch(
                        error => {
                            this.logout();
                        }
                    );
            } else {
                this.logout();
            }
        }).catch(
            error => {
                this.logout();
            }
        );
    }

    register(email: string, password: string) {

        const headerX = new HttpHeaders({
            'x-static-key': this.env.X_STATIC_KEY
        });

        return this.http.post(this.env.API_URL + 'auth/register',
            { 'username': email, 'password': password }, { headers: headerX }
        ).pipe(
            tap(data => {

                this.navCtrl.navigateRoot(['login']);
                return data;
            }),
        );
    }

    logout() {
        this.http.post(this.env.API_URL + 'auth/logout', {});
        this.storage.remove('refresh_token').then(() => {
            this.storage.remove('token').then(() => {
                this.navCtrl.navigateRoot(['login']);
                this.authState.next(false);
            });
        });
    }


    isAuthenticated() {
        return this.authState.value;
    }

}
